import { useState, useEffect } from 'react';
import { AnimatePresence } from 'framer-motion';
import SwipeSlide from '../components/SwipeSlide';
import Welcome from '../components/slide/Welcome';
import Staff from '../components/slide/Staff';
import Service from '../components/slide/Service';
import Activities from '../components/slide/Activities';
import Reserve from '../components/slide/Reserve';
import ExternalLink from '../components/slide/ExternalLink';
import '../styles/lightEffect.css';
import '../styles/swipeGuide.css';

const slideBackgrounds = [
  '#CCFFCC',
  '#CCFFCC',
  '#CCFFCC',
  '#CCFFCC',
  '#CCFFCC',
  '#CCFFCC',
];

export default function LandingPage() {
  const [index, setIndex] = useState(0);
  const [showSwipeGuide, setShowSwipeGuide] = useState(true);
  const [isTouchDevice, setIsTouchDevice] = useState(false);
  const [lastInteractionTime, setLastInteractionTime] = useState(Date.now());

  // 年配ユーザー向け設定
  const GUIDE_DISPLAY_TIME = 3000; // 3秒間表示

  // デバイス種別の判定
  useEffect(() => {
    setIsTouchDevice('ontouchstart' in window || navigator.maxTouchPoints > 0);
  }, []);

  // 年配ユーザー向け：常に定期的にガイドを表示
  useEffect(() => {
    let guideTimer: NodeJS.Timeout;

    const showGuide = () => {
      setShowSwipeGuide(true);

      // 設定された時間後に非表示
      guideTimer = setTimeout(() => {
        setShowSwipeGuide(false);
      }, GUIDE_DISPLAY_TIME);
    };

    const resetGuideInterval = () => {
      clearTimeout(guideTimer);

      // 初回表示
      showGuide();
    };

    resetGuideInterval();

    return () => {
      clearTimeout(guideTimer);
    };
  }, [lastInteractionTime]);
  const paginate = (direction: number) => {
    const newIndex =
      (index + direction + slideBackgrounds.length) % slideBackgrounds.length;
    setIndex(newIndex);

    // スワイプ操作時刻を記録し、ガイドを一時的に非表示
    setLastInteractionTime(Date.now());
    setShowSwipeGuide(false);
  };

  // 👉 indexごとの表示をswitchで切り替える関数
  const getSlideContent = () => {
    switch (index) {
      case 0:
        return <Welcome />;
      case 1:
        return <Staff />;
      case 2:
        return <Service />;
      case 3:
        return <Activities />;
      case 4:
        return <Reserve />;
      case 5:
        return <ExternalLink />;
      default:
        return null;
    }
  };

  return (
    <>
      {/* 光のエフェクト */}
      <div className="light-effect-container">
        <div className="light-particle"></div>
        <div className="light-particle"></div>
        <div className="light-particle"></div>
        <div className="light-particle"></div>
        <div className="light-particle"></div>
        <div className="light-particle"></div>
        <div className="light-particle"></div>
        <div className="light-particle"></div>
        <div className="light-orb"></div>
        <div className="light-orb"></div>
        <div className="light-ray"></div>
        <div className="light-ray"></div>
      </div>

      {/* スワイプガイドアニメーション */}
      {showSwipeGuide && (
        <div className="swipe-guide-container">
          <div className="swipe-guide-left">
            <div className="swipe-gesture">
              <div className="hand-icon">{isTouchDevice ? '👆' : '🖱️'}</div>
              <div className="swipe-arrow left-arrow">←</div>
            </div>
            <div className="swipe-text">
              {isTouchDevice ? '左にスワイプ' : '左にドラッグ'}
            </div>
          </div>

          <div className="swipe-guide-right">
            <div className="swipe-gesture">
              <div className="hand-icon">{isTouchDevice ? '👆' : '🖱️'}</div>
              <div className="swipe-arrow right-arrow">→</div>
            </div>
            <div className="swipe-text">
              {isTouchDevice ? '右にスワイプ' : '右にドラッグ'}
            </div>
          </div>

          <div className="swipe-guide-center">
            {/* <div className="pulse-indicator"></div> */}
            <div className="guide-message">
              {isTouchDevice
                ? '左右にスワイプしてページを切り替え'
                : '左右にドラッグしてページを切り替え'}
            </div>
          </div>

          {/* タッチインジケーター（タッチデバイスのみ） */}
          {isTouchDevice && (
            <>
              <div className="touch-indicator left"></div>
              <div className="touch-indicator right"></div>
            </>
          )}
        </div>
      )}

      <AnimatePresence custom={index}>
        <SwipeSlide
          key={index}
          bg={slideBackgrounds[index]}
          content={getSlideContent()}
          onSwipeLeft={() => paginate(1)}
          onSwipeRight={() => paginate(-1)}
        />
      </AnimatePresence>
    </>
  );
}
